import React from 'react';
import { Wine, Heart, Users } from 'lucide-react';

const FEATURES = [
  {
    Icon: Wine,
    title: 'Premium Quality',
    body: 'High-quality wine kits that your guests will love',
  },
  {
    emoji: '💰',
    title: 'Cost Effective',
    body: 'Save significantly compared to buying wine for your reception',
  },
  {
    Icon: Heart,
    title: 'Personalized',
    body: 'Custom labels with your names, wedding date, and design',
  },
  {
    Icon: Users,
    title: 'Fun Experience',
    body: 'Include your wedding party in a memorable bottling experience',
  },
];

const WeddingsWhyChoose = () => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
        Why Choose The Lokal for Your Wedding
      </h2>
      <div className="grid md:grid-cols-4 gap-8">
        {FEATURES.map((f) => (
          <div key={f.title} className="text-center">
            <div className="bg-[#FDB913]/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              {f.Icon ? <f.Icon className="w-8 h-8 text-[#FDB913]" /> : <span className="text-2xl">{f.emoji}</span>}
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">{f.title}</h3>
            <p className="text-sm text-gray-600">{f.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WeddingsWhyChoose;
